<template>
  <v-container>
    <div class="quota-allocation-pg">
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ $t('Квоты') }}</h1>
      <div class="my-organization">
        <div class="quotas-pg bgw-pdg-20">
          <div class="flex-two-col">
            <div class="flex-two-col__left">
              <Menu/>
            </div>
          </div>
          <div class="flex-two-col">
            <div class="flex-two-col__left">
              <ul class="list-column">
                <li v-for="(year, i) in refYear" :class="{ active: year.id === yearId }" :key="i">
                  <a href="#" @click="changeYear(year.id)">{{ year.year }}</a>
                </li>
              </ul>
            </div>
            <div class="flex-two-col__right">
              <ul class="list-column">
                <li>
                  <a
                    href="#"
                    @click.prevent="goToQuotaCancellation"
                  >{{ $t('Аннулировать квоты') }}</a>
                </li>
                <li>
                  <a href="#" @click="printWord">{{ $t('Печать текущих квот') }}</a>
                </li>
              </ul>
            </div>
            <div class="table-overflow">
              <h4>{{$t('Квоты - сводная таблица')}}</h4>
              <table class="table-full">
                <thead>
                <tr>
                  <td>{{ $t('Охотпользователь') }}</td>
                  <td>{{ $t('Вид животного') }}</td>
                  <td>{{ $t('Выдано голов') }}</td>
                  <td>{{ $t('Аннулировано голов') }}</td>
                  <td>{{ $t('Из них использовано голов') }}</td>
                  <td>{{ $t('Остаток голов') }}</td>
                </tr>
                </thead>
                <tbody>
                <template v-for="item in summaryQuotas" >
                  <tr v-for="i in item" :key="i.quotaId">
                    <td>{{ i.oopt }}</td>
                    <td>{{ i.fauna }}</td>
                    <td>{{ i.allocated }}</td>
                    <td>{{ i.cancelled }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <div class="search-head">
            <h4>{{$t('Записи о квотах')}}</h4>
            <v-row>
              <v-col>
                <v-label>{{ $t('Организация') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="oopts"
                    item-value="id"
                    item-text="transName"
                    v-model="search.oopt"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
              <v-col>
                <v-label>{{ $t('Область') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="refSoates"
                    item-value="id"
                    item-text="transName"
                    v-model="search.region"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
              <v-col>
                <v-label>{{ $t('Вид животного') }}</v-label>
                <div class="select-def">
                  <v-select
                    :items="faunas"
                    item-value="id"
                    item-text="transName"
                    v-model="search.fauna"
                    :placeholder="$t('Все')"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <div class="search-action">
              <button
                class="btn btn-default green-grassy"
                @click="getQuotaList()"
              >
                {{ $t('Поиск') }}
              </button>
              <button
                class="btn btn-default gray"
                @click="search = {}, getQuotaList()"
              >
                {{ $t('Очистить') }}
              </button>
            </div>
          </div>
          <div class="search-body">
            <div class="table-overflow">
              <table class="table-full">
                <thead>
                <tr>
                  <td class="td-num">№</td>
                  <td>
                    <div class="sort-flex">
                      {{ $t('Дата') }}
                      <a @click="sort('date')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'date' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td>
                    <div class="sort-flex">
                      {{ $t('Охотпользователь') }}
                      <a @click="sort('oopt')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'oopt' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td>
                    <div class="sort-flex">
                      {{ $t('Вид животного') }}
                      <a @click="sort('fauna')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'fauna' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td>{{ $t('Кол-во голов') }}</td>
                  <td>
                    <div class="sort-flex">
                      {{ $t('Действие') }}
                      <a @click="sort('status')" class="sort-btn sort-blue">
                        <v-icon v-if="sortParams.field == 'status' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                        <v-icon v-else>arrow_drop_down</v-icon>
                      </a>
                    </div>
                  </td>
                  <td>{{ $t('Квота итого') }}</td>
<!--                  <td>{{ $t('Из них использовано') }}</td>-->
<!--                  <td>{{ $t('Остаток') }}</td>-->
                  <td>{{ $t('Пользователь') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in quotas" :key="i">
                  <td class="td-num">{{ i + 1 }}</td>
                  <td>{{ new Date(item.date) | dateFormat('DD.MM.YYYY') }}</td>
                  <td>{{ item.oopt }}</td>
                  <td>{{ item.fauna }}</td>
                  <td>{{ item.headCount }}</td>
                  <td>
                    {{ item.status }}
                    <router-link
                      v-if="item.quotaApplicationId"
                      tag="a"
                      :to="{ name: 'quota-view', params: { id: item.quotaApplicationId } }"
                    >
                      {{ $t('Заявка') }}
                    </router-link>
                    <router-link
                      v-if="item.quotaCancelledId"
                      tag="a"
                      :to="{ name: 'quota-cancellation-view', params: { id: item.quotaCancelledId } }"
                    >
                      {{ $t('Аннулирование') }}
                    </router-link>
                  </td>
                  <td>{{ item.totalQuota }}</td>
<!--                  <td></td>-->
<!--                  <td></td>-->
<!--                  <td></td>-->
                  <td>{{ item.userFio }}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <v-pagination
              v-model="page"
              :length="paginationData.pageCount"
              total-visible="10"
            />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import Menu from '@/components/quota/Menu'
import Quota from '@/model/quota'
import { mapMutations } from 'vuex'

export default {
  components: {
    Menu
  },
  data: () => ({
    page: 1,
    paginationData: {},
    breadcrumbs: [],
    refYear: [],
    faunas: [],
    refSoates: [],
    oopts: [],
    yearId: null,
    quotas: [],
    summaryQuotas: [],
    sortParams: {
      field: 'date',
      order: 'ASC'
    },
    search: {}
  }),
  watch: {
    page () {
      this.getQuotaList(false)
    },
    yearId () {
      this.getQuotaList()
      this.getSummaryQuotas()
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Quota.getQuotaFilterData()
        .then((res) => {
          this.refYear = res.data.refYears
          this.faunas = res.data.faunas
          this.refSoates = res.data.refSoates
          this.oopts = res.data.oopts
          const currentYear = new Date().getFullYear()
          this.refYear.forEach((e) => {
            if (+e.year === currentYear) this.yearId = e.id
          })
          this.setLoading(false)
        })
        .catch((err) => {
          console.log(err)
          this.setLoading(false)
        })
      this.generateBreadcrumbs()
    },
    getQuotaList (resetPage = true) {
      this.setLoading(true)
      if (resetPage) this.page = 1
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      Quota.listQuota(this.yearId, this.search)
        .then((res) => {
          this.quotas = res.data.items
          this.paginationData = res.data.paginationData
          this.setLoading(false)
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
    },
    getSummaryQuotas () {
      this.setLoading(true)
      Quota.getSummaryTableByYear(this.yearId)
        .then((res) => {
          this.summaryQuotas = res.data
          this.setLoading(false)
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.getQuotaList()
    },
    changeYear (id) {
      this.yearId = id
    },
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Квоты'),
          disabled: true
        }
      ]
    },
    // печать в ворд
    printWord () {
      this.setLoading(true)
      Quota.printUserQuotas(this.yearId)
        .then(res => {
          if (res.status === 400) {
            this.$noty.warning(this.$i18n.t('Ошибка'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          } else {
            this.forceFileDownload(res)
          }
        })
        .catch(() => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })

      this.setLoading(false)
    },
    // генерация ссылки для скачивания ворд файла
    forceFileDownload (res) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'quotas.docx')
      document.body.appendChild(link)
      link.click()
    },
    // переход на страницу "Аннулирование квоты"
    goToQuotaCancellation () {
      this.refYear.forEach((element) => {
        if (element.id === this.yearId) {
          this.$router.push({
            name: 'quota-cancellation',
            query: {
              year: element.year,
              yearId: this.yearId
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
